import definition from '@/helpers/rave/constants/definitions'

export default {
  [definition.NONE]: 'None',
  [definition.SINGLE]: 'Single',
  [definition.SPLIT]: 'Split',
  [definition.TRIPLE_SPLIT]: 'Triple split',
  [definition.QUADRUPLE_SPLIT]: 'Quadruple Split'
}
